import { ReactNode } from "react";

import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Button from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";
import MobileView from "components/Mobile/MobileView";
import DesktopView from "components/Mobile/DesktopView";
import SearchInput from "components/SearchInput";
import { SEARCH_PLACEHOLDERS } from "constants/searchPlaceholders";
import DocumentationIconButton from "components/DocumentationIconButton";
import { getDocsUrl } from "utils/getDocsUrl";
import useCanCreateIntentProject from "shared/IntentProject/access/useCanCreateIntentProject";

import { showCreateIntentProjectDrawer } from "./CreateIntentProjectDrawer";
import { FILTERS_ORDER_SETTINGS_KEY } from "./constants";

type IntentProjectsPageLayoutProps = {
  children: ReactNode;
  hideActions?: boolean;
  pageIsEmpty: boolean;
};

const IntentProjectsPageLayout = ({
  children,
  hideActions = false,
  pageIsEmpty,
}: IntentProjectsPageLayoutProps) => {
  const canCreateIntentProject = useCanCreateIntentProject();

  return (
    <>
      <ViewHeader firstLevel>
        <ViewHeaderWrapper>
          <ViewHeaderTitle>Intent Projects</ViewHeaderTitle>
          <MobileView>
            {!hideActions && (
              <Tooltip
                on={(props) => (
                  <Button
                    {...props}
                    onPress={() => showCreateIntentProjectDrawer()}
                    variant="primary"
                    disabled={!canCreateIntentProject.result}
                  >
                    Create intent project
                  </Button>
                )}
                active={!!canCreateIntentProject.message}
              >
                {canCreateIntentProject.message}
              </Tooltip>
            )}
          </MobileView>
        </ViewHeaderWrapper>

        <ViewHeaderWrapper>
          <SearchInput
            placeholder={SEARCH_PLACEHOLDERS.PROJECTS}
            filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
            disabled={pageIsEmpty}
          />

          <DocumentationIconButton
            href={getDocsUrl("/concepts/intelligence/intent")}
            tooltipText="Go to intent projects documentation"
          />

          {!hideActions && (
            <DesktopView>
              <Tooltip
                on={(props) => (
                  <Button
                    {...props}
                    onPress={() => showCreateIntentProjectDrawer()}
                    variant="primary"
                    disabled={!canCreateIntentProject.result}
                  >
                    Create intent project
                  </Button>
                )}
                active={!!canCreateIntentProject.message}
              >
                {canCreateIntentProject.message}
              </Tooltip>
            </DesktopView>
          )}
        </ViewHeaderWrapper>
      </ViewHeader>

      {children}
    </>
  );
};

export default IntentProjectsPageLayout;
